import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import SelectOrCreateFileInput from 'files/components/SelectOrCreateFileInput';
import SearchInput from 'search/inputs/SearchInput';

interface SearchEditorProps {
  config: string | null;
  onChangeConfig: (config: string | null) => void;
  modelTypes: Array<ModelTypeConstants>;
  schemaIds?: Array<string> | null;
  schemaInterfaceIds?: Array<string> | null;
  disabled?: boolean;
}

export default function SearchEditor({
  config,
  onChangeConfig,
  disabled,
  modelTypes,
  schemaIds,
  schemaInterfaceIds,
}: SearchEditorProps): JSX.Element {
  if (modelTypes.length > 0 && modelTypes.every((modelType) => modelType === ModelTypeConstants.FILE)) {
    return (
      <SelectOrCreateFileInput
        disabled={disabled}
        isMulti={false}
        onRemove={() => {
          onChangeConfig(null);
        }}
        onSelect={(itemId) => {
          onChangeConfig(itemId.length > 0 ? itemId[0] : null);
        }}
        placeholder=""
        selected={config == null ? [] : [config]}
      />
    );
  } else {
    return (
      <SearchInput
        autoFocus={false}
        disabled={disabled}
        disableTyping={config != null}
        isMulti={false}
        onRemove={() => {
          onChangeConfig(null);
        }}
        onSelect={(itemId) => {
          onChangeConfig(itemId);
        }}
        placeholder=""
        schemaIds={schemaIds ?? undefined}
        schemaInterfaceIds={schemaInterfaceIds ?? undefined}
        selected={config == null ? [] : [config]}
        types={modelTypes}
      />
    );
  }
}
